import produce from 'immer';
import * as CONSTANTS from './constants';

const initState = {
  isLoading: false,
  error: null,
  flags: {},
};

const featureFlagsReducer = (state = initState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case CONSTANTS.FETCH_FEATURE_FLAGS_REQUEST:
        draft.isLoading = true;
        draft.error = null;
        break;

      case CONSTANTS.FETCH_FEATURE_FLAGS_SUCCESS:
        draft.isLoading = false;
        draft.flags = action.data; // store the flag from API
        draft.error = null;
        break;

      case CONSTANTS.FETCH_FEATURE_FLAGS_FAIL:
        draft.isLoading = false;
        draft.error = action.error;
        break;

      default:
        return state;
    }
  });

export default featureFlagsReducer;